import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GameStatsWrap from './GameStats.styled';
import MoveCount from '../../atoms/MoveCount/MoveCount';
import TimeRemaining from '../../atoms/TimeRemaining/TimeRemaining';
import TimeTaken from '../../atoms/TimeTaken/TimeTaken';
import TimeBar from '../../atoms/TimeBar/TimeBar';

const mapStateToProps = state => ({
  time: state.gameData[state.saved.level].time,
  timeLeft: state.game.time,
  timeTaken: state.game.timeTaken,
  started: state.game.started,
  restarted: state.game.restarted,
  countUp: state.settings.countUp,
  countDown: state.settings.countDown,
});

const GameStats = ({
  time,
  timeLeft,
  timeTaken,
  started,
  restarted,
  countDown,
  countUp,
}) => (
  <GameStatsWrap>
    <MoveCount />
    {countUp && <TimeTaken timeTaken={timeTaken} />}
    {countDown && (
      <Fragment>
        <TimeRemaining timeLeft={timeLeft} />
        <TimeBar time={time} started={started} restarted={restarted} />
      </Fragment>
    )}
  </GameStatsWrap>
);

export default connect(mapStateToProps)(GameStats);

GameStats.propTypes = {
  time: PropTypes.number.isRequired,
  timeLeft: PropTypes.number,
  timeTaken: PropTypes.number,
  started: PropTypes.bool.isRequired,
  restarted: PropTypes.bool.isRequired,
  countDown: PropTypes.bool.isRequired,
  countUp: PropTypes.bool.isRequired,
};

GameStats.defaultProps = {
  timeLeft: 0,
  timeTaken: 0,
};



// WEBPACK FOOTER //
// ./src/components/molecules/GameStats/GameStats.js